module.exports = __webpack_public_path__ + "static/media/02-icon.8ea56fe0.svg";